import * as React from 'react'
import { cn } from '../lib/utils'

/**
 * RTL-safe Input.
 *
 * The component inherits `direction` from `<html>` (set to `rtl` in
 * `apps/web/index.html`), so callers should not hard-code text alignment.
 * Use `text-start`/`text-end` if needed instead of `text-left`/`text-right`.
 */
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        className={cn(
          'flex h-10 w-full rounded-md border border-brand-200 bg-white ps-3 pe-3 py-2 text-sm text-brand-900 ring-offset-white placeholder:text-brand-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 file:border-0 file:bg-transparent file:text-sm file:font-medium',
          className,
        )}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
